var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "footer", attrs: { id: "footer" } }, [
    _c("div", { staticClass: "copyright" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: _vm.getLogoImgUrl(), alt: "" },
      }),
      _c("span", { staticClass: "version" }, [
        _vm._v("Version: " + _vm._s(_vm.version)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }